import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const CustomLink = ({ children, pathname, className = '' }) => {
  const location = useLocation();

  return (
    <Link
      className={className}
      to={{ pathname, state: { from: location } }}
      style={{ textDecoration: 'none' }}
    >
      {children}
    </Link>
  );
};

export default CustomLink;
